<!--
 * @Author: xuhuining
 * @Date: 2022-03-21 14:12:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-04 14:54:52
 * @Description: 独家策划
-->
<template>
  <div class="exclusive_panning" v-if="exclusivePanningList.length > 0">
    <div class="title">
      <div class="left">独家策划</div>
      <div class="right" @click="toExclusivePanning()">
        更多
        <van-icon name="arrow" />
      </div>
    </div>
    <div class="content">
      <div
        class="item"
        v-for="item in exclusivePanningList"
        :key="item.id"
        @click="toSpecialTopic(item)"
      >
        <img :src="item.coverUrl" alt />
        <div class="text">{{ item.name }}</div>
      </div>
      <div class="more_recommend" @click="toExclusivePanning()">
        <span>更多推荐</span>
        <van-icon name="arrow" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "exclusivePanning",
  props: {
    exclusivePanningList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    // 更多
    toExclusivePanning() {
      this.$router.push("/exclusivePanningList");
    },
    toSpecialTopic(item) {
      this.$emit('toSpecialTopic', item)
    }
  }
};
</script>
<style lang="less" scoped>
.exclusive_panning {
  margin: 0 auto 0;
  width: 343px;
  height: 146px;
  padding: 12px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px;
  .title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: #333333;
    .left {
      font-size: 15px;
      font-weight: bold;
    }
    .right {
      font-size: 12px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
  .content {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    // justify-content: flex-start;
    padding-top: 8px;
    .item {
      margin-right: 8px;
      min-width: 101px;
      width: 101px;
      img {
        width: 100%;
        height: 68px;
        display: block;
        border-radius: 10px;
      }
      .text {
        padding: 8px 0 12px;
        font-size: 13px;
        font-weight: bold;
        width: 85px;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        box-sizing: border-box;
        margin: auto;
      }
    }
    .more_recommend {
      min-width: 101px;
      height: 68px;
      line-height: 66px;
      background: #fef4de;
      border-radius: 8px;
      display: flex;
      align-items: center;
      color: #b18925;
      font-size: 12px;
      justify-content: center;
      margin-right: 12px;
    }
    .item:first-child {
      padding-left: 0px;
    }
  }
.content::-webkit-scrollbar {display:none}
}
</style>